<template>
  <!-- 地图视图 -->
  <div v-if="samplesList.length == 0">
    <div style="overflow: hidden">
      <empty text="没有样本" style="margin-top: 40%;  transform: translateY(-50%)"></empty>
    </div>
  </div>

  <div class="relative-position" v-else>
    <div class="map-area" id="_leader_map"></div>
    <div
      class="bmap-custom-marker-controller"
      style="position: absolute; right: 25px; top: 10px"
    >
      <div
        class="bmap-custom-marker-control"
        :class="{
          'bmap-custom-marker-control-active': selectedType === type.key_prefix,
        }"
        v-for="type in pointType"
        :key="type.key_prefix"
        @click="selectedType = type.key_prefix"
      >
        {{ type.label }}
      </div>
    </div>
  </div>

  
</template>

<script>
import BMapMixin from "@/mixins/bmap.mixin";
import LeaderCommonStatus from "../mixins/status.mixin";
const customMarkPointLoader = () => import("@/libs/CustomMarkPoint");
const customMakePointControlLoader = () =>
  import("@/libs/CustomMarkPointStyleController");

export default {
  mixins: [BMapMixin, LeaderCommonStatus],
  props: ["samplesprop"],
  components: {
    LockMask: () => import("../../../components/Mask"),
    Empty: () => import("../../../components/Empty"),
    Loading: () => import("../../../components/Loading"),
  },
  data() {
    return {
      loading: false,
      samplesList: [],
      pointType: [
        { key_prefix: "dom", label: "注册地址" },
        { key_prefix: "addr", label: "经营地址" },
        { key_prefix: "entname", label: "地图检索地址" },
      ],
      selectedType: "dom",
    };
  },

  computed: {
    samplesFromProp() {
      return this.samplesprop;
    },
  },

  watch: {
    selectedType(newType) {
      if (newType) {
        this.renderMap();
      }
    },

    samplesFromProp: {
      immediate: true,
      handler(samples) {
        this.samplesList = samples;
        if (this.samplesList.length != 0) {
          this.renderMap();
        }
      },
    },
  },

  mounted() {},

  methods: {
    async renderMap() {
      await this.renderSamplesGroupByStatus(
        this.samplesList,
        this.selectedType,
        "_leader_map",
        () => {}
      );
    },
  },
};
</script>

<style scoped lang="scss">
.map-area {
  height: 100%;
}
</style>
